import { render, staticRenderFns } from "./ScaleHorizontally.vue?vue&type=template&id=3880d6b0&scoped=true&"
import script from "./ScaleHorizontally.vue?vue&type=script&lang=js&"
export * from "./ScaleHorizontally.vue?vue&type=script&lang=js&"
import style0 from "./ScaleHorizontally.vue?vue&type=style&index=0&id=3880d6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3880d6b0",
  null
  
)

export default component.exports